<template>
  <v-col cols="12">
    <v-form ref="form">
      <base-card>
        <v-card-title>Transacciones TEF</v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
              sm="4"
            >
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="dataFilter.dates"
                persistent
                width="290px"
              >
                <template v-slot:activator="{on, attrs}">
                  <v-text-field
                    v-model="dataFilter.dates"
                    label="Rango de fechas"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="dataFilter.dates"
                  range
                  locale="es"
                >
                  <v-spacer />
                  <v-btn
                    text
                    style="background-color:rgb(204 33 40);color:white !important"
                    @click="modal = false"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    text
                    style="background-color:rgb(204 33 40);color:white !important"
                    @click="$refs.dialog.save(dataFilter.dates)"
                  >
                    Aceptar
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>

            <v-col
              cols="12"
              sm="4"
            >
              <v-select
                v-model="dataFilter.TipoTransaccion"
                :items="transactionType"
                item-text="textStatus"
                item-value="valueStatus"
                label="Tipo de transacción"
                prepend-inner-icon="mdi-order-bool-descending-variant"
              />
            </v-col>

            <v-col
              cols="12"
              sm="4"
            >
              <v-select
                v-model="dataFilter.TipoTef"
                :items="tefTypes"
                item-text="textCredential"
                item-value="valueCredential"
                label="Tipo Tef"
                prepend-inner-icon="mdi-order-bool-descending-variant"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="4"
            >
              <v-text-field
                v-model="dataFilter.NumeroAutorizacion"
                label="Número de autorización"
                prepend-inner-icon="mdi-numeric"
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-text-field
                v-model="dataFilter.IdTransaccion"
                label="ID transacción"
                prepend-inner-icon="mdi-numeric"
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-btn
                class="ma-2"
                style="background-color:rgb(204 33 40);color:white !important"
                @click="searchTransaction"
              >
                Buscar
              </v-btn>
              <v-btn
                class="ma-2"
                color="GRAY"
                @click="clearForm"
              >
                Nueva Búsqueda
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-btn
                class="ma-2"
                style="background-color:rgb(204 33 40);color:white !important"
                @click="generateCaptureFile"
              >
                Generar archivo de Captura
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="3"
            >
              <v-btn
                class="ma-2"
                style="background-color:rgb(204 33 40);color:white !important"
                @click="generateCsvFile"
              >
                Generar archivo CSV
              </v-btn>
            </v-col>
            <v-row
              v-if="searchTransactionProgress == true"
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-col cols="6">
                <v-col
                  class="text-subtitle-1 text-center"
                  cols="12"
                >
                  Consultando Transacciones
                </v-col>
                <v-progress-linear
                  color="red darken-4"
                  indeterminate
                  rounded
                  height="6"
                />
              </v-col>
            </v-row>
            <v-alert
              v-show="successAlert"
              type="success"
              text
            >
              {{ msgSuccessAlert }}
            </v-alert>
            <v-alert
              v-show="errorAlert"
              type="error"
              text
            >
              {{ errorAlertMsg }}
            </v-alert>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-alert
                v-if="notFoundTransaction"
                text
                type="info"
              >
                No se encontraron <strong>Transacciones</strong> para los filtros aplicados.
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>
      </base-card>
    </v-form>
  </v-col>
</template>

<script >
  import { listTefTransactionTypes, listTefTransactionStatus } from '@/data/listTefTransactionTypes'
  import { listTefTypes } from '@/data/listTefTypes'
  import { mapState } from 'vuex'

  export default {
    name: 'FilterTransactionsHistory',
    data: () => ({
      notFoundTransaction: false,
      searchTransactionProgress: false,
      modal: false,
      datepickerFinal: false,
      dateFinal: null,
      transactionType: listTefTransactionTypes,
      tefTypes: listTefTypes,
      tefStatus: listTefTransactionStatus,
      dataFilter: {
        TipoTef: '999',
        dates: [],
      },
      msgSuccessAlert: '',
      successAlert: false,
      errorAlert: false,
      errorAlertMsg: '',
    }),
    created () {
      this.searchTransactionProgress = true
      this.dataFilter.dates = this.setInitialFilteredDates()
    },
    computed: {
      ...mapState('historyTef', [
        'listTransactions',
      ]),
      statusResponseDownloadCaptureFile () {
        return this.$store.state.historyTef.statusResponse
      },
      statusResponseDownloadCaptureFileMsg () {
        return this.$store.state.historyTef.statusResponseMsg
      },
    },
    watch: {
      listTransactions () {
        if (this.$store.state.historyTef.listTransactions) {
          this.searchTransactionProgress = false
          if (this.$store.state.historyTef.listTransactions.length > 0) {
            this.notFoundTransaction = false
          } else {
            this.notFoundTransaction = true
            setTimeout(() => {
              this.notFoundTransaction = false
            }, 4000)
          }
        }
      },
      statusResponseDownloadCaptureFile () {
        if (this.statusResponseDownloadCaptureFile === false) {
          this.generateErrorAlert(this.statusResponseDownloadCaptureFileMsg)
          this.$store.dispatch('historyTef/setStatusResponseDownloadCaptureFile', null)
        }
      },
    },
    methods: {
      searchTransaction () {
        this.notFoundTransaction = false
        this.searchTransactionProgress = true
        this.$store.dispatch('historyTef/getListTransactions', {
          ...this.dataFilter,
        })
      },
      generateCaptureFile () {
        this.$store.dispatch('historyTef/downloadCaptureFile', {
          ...this.dataFilter,
        })
      },
      generateCsvFile () {
        const fields = [
          'id',
          'company_id',
          'store_code',
          'terminal_code',
          'tef_type_code',
          'acquirer_network',
          'transaction_type',
          'hiopos_transaction_type',
          'authorization_number',
          'hiopos_transaction_id',
          'reference',
          'status',
          'batch_number',
          'total_amount',
          'fixed_amount',
          'tax_amount',
          'tax_base_amount',
          'zero_rate_base_amount',
          'tip_amount',
          'service_amount',
          'interest_amount',
          'read_mode',
          'cardholder',
          'acquirer_name',
          'emv_application',
          'installments',
          'grace_months',
          'credit_type',
          'transaction_indicator',
          'transaction_datetime',
          'created_at',
        ]

        if (this.$store.state.historyTef.listTransactions.length !== 0) {
          const header = fields.join(',') + '\n'

          const rows = this.$store.state.historyTef.listTransactions.map(item => {
            return fields.map(field => item[field]).join(',')
          }).join('\n')

          const csvContent = header + rows

          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
          const url = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = 'transacciones.csv'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          URL.revokeObjectURL(url)
        } else {
          this.generateErrorAlert('Para poder generar el archivo CSV, debe realizar una consulta al Historial de transacciones.')
        }
      },
      generateErrorAlert (msj) {
        this.errorAlertMsg = msj
        this.errorAlert = true
        setTimeout(() => {
          this.errorAlert = false
        }, 4000)
      },
      setInitialFilteredDates () {
        let currentDate = new Date()
        currentDate = currentDate.getFullYear() + '-' + String(currentDate.getMonth() + 1).padStart(2, '0') + '-' + String(currentDate.getDate()).padStart(2, '0')
        return [
          currentDate,
          currentDate,
        ]
      },
      clearForm () {
        this.$refs.form.reset()
      },
    },
  }
</script>
